module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"noItemsText":"No pages to show."},"fi":{"noItemsText":"Sivuja ei löytynyt."},"sv":{"noItemsText":"Det finns inga sidor att visa."}}')
  delete Component.options._Ctor
}
